
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 8.5V5a2 2 0 012-2h3.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H5v3.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5zM15.5 5H19v3.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V5a2 2 0 00-2-2h-3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5zm-7 14H5v-3.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V19a2 2 0 002 2h3.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm12-4h-1a.5.5 0 00-.5.5V19h-3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H19a2 2 0 002-2v-3.5a.5.5 0 00-.5-.5zm1-4h-19a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h19a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z","fill-rule":"evenodd","opacity":".8"}})])
          )
        }
      }
    